import React from "react";
import "./Outils.css";
import { usePanier, Outil, PanierElement, outilListe } from "../PanierContext";

const Outils: React.FC = () => {
  const { panier, setPanier } = usePanier();

  // 🔹 Ajouter un outil ou incrémenter sa quantité
  const handleAjouter = (idOutil: number) => {
    setPanier((prev: PanierElement[]) => {
      const existant = prev.find((el) => el.idOutil === idOutil);
      if (existant) {
        return prev.map((el) =>
          el.idOutil === idOutil ? { ...el, nombre: el.nombre + 1 } : el
        );
      }
      return [...prev, { idOutil, nombre: 1 }];
    });
  };

  // 🔹 Diminuer la quantité
  const handleDiminuer = (idOutil: number) => {
    setPanier((prev: PanierElement[]) =>
      prev
        .map((el) =>
          el.idOutil === idOutil ? { ...el, nombre: el.nombre - 1 } : el
        )
        .filter((el) => el.nombre > 0)
    );
  };

  // 🔹 Supprimer complètement un outil
  const handleSupprimer = (idOutil: number) => {
    setPanier((prev: PanierElement[]) =>
      prev.filter((el) => el.idOutil !== idOutil)
    );
  };

  // 🔹 Trouver la quantité d’un outil
  const getQuantite = (idOutil: number): number => {
    const el = panier.find((p) => p.idOutil === idOutil);
    return el ? el.nombre : 0;
  };

  return (
    <div className="outils-container">
      {outilListe.map((outil: Outil) => {
        const quantite = getQuantite(outil.id);

        return (
          <div key={outil.id} className="outil-hero">
            <img src={outil.image} alt={outil.nom} className="outil-image" />
            <div className="outil-overlay">
              <p className="outil-description">
                Outil de rétablissement "{outil.nom}"
              </p>
              <div className="outil-bottom-row">
                <p className="outil-prix">{(outil.prix / 100).toFixed(2)}€ </p>

                {/* 🔸 Si pas encore dans le panier → bouton Ajouter */}
                {quantite === 0 ? (
                  <button
                    className="outil-button"
                    onClick={() => handleAjouter(outil.id)}
                  >
                    Ajouter au panier
                  </button>
                ) : (
                  // 🔸 Sinon, affichage des boutons + / - / supprimer
                  <div className="outil-quantite">
                    <button
                      className="outil-button moins"
                      onClick={() => handleDiminuer(outil.id)}
                    >
                      –
                    </button>

                    <span className="quantite">{quantite}</span>

                    <button
                      className="outil-button plus"
                      onClick={() => handleAjouter(outil.id)}
                    >
                      +
                    </button>

                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Outils;
